import { Button, Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ReactComponent as PlusRoundIcon } from "images/plus-round.svg";
import { AddCompanyModal } from "./AddCompanyModal";
import { CompanyEntity } from "interfaces";

type AddCompanyProps = {
  onDataReceived?: (data: CompanyEntity) => void;
  isReport?: boolean;
};
export const AddCompanyButton = observer(({ onDataReceived, isReport }: AddCompanyProps) => {
  const { actionModals } = useStores();

  const btnTitle = isReport
    ? "Выбрать компанию для составления отчета"
    : "Подключить дополнительную компанию для пользователя";

  const addCompanyHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    actionModals.open(() => <AddCompanyModal onDataReceived={onDataReceived} isReport={isReport} />, {
      width: "600px",
      noValidation: true,
      title: "Выберите компанию",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Tooltip title={btnTitle}>
      <Button type="link" size="small" icon={<PlusRoundIcon />} onClick={addCompanyHandler} />
    </Tooltip>
  );
});
